// Componente para mostrar la galería de videos del perfil
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './perfilvideo.css';
const API_URL = `${process.env.REACT_APP_PUBLICACIONES_URL}/get_videos.php`;
const formatCount = (num) => {
  const n = Number(num) || 0;
  if (n >= 1000000) {
    return Math.round(n / 1000000) + ' M';
  }
  return n.toLocaleString('es-CL');
};
const getViewerToken = () => {
  let token = localStorage.getItem('viewer_token');
  if (!token) {
    token = 'vt_' + Date.now() + '_' + Math.random().toString(36).substring(2, 12);
    localStorage.setItem('viewer_token', token);
  }
  return token;
};
const LikeBadge = ({ liked, count, onClick }) => (
  <div className="badge-wrap">
    <div className="badge" onClick={onClick}>
      <div className="icon-row">
        <i className={`fas fa-heart heart${liked ? ' liked' : ''}`}></i>
        <span className="num">{formatCount(count)}</span>
      </div>
    </div>
  </div>
);
const VistasBadge = ({ count }) => (
  <div className="badge-wrap">
    <div className="badge badge-static">
      <div className="icon-row">
        <i className="fas fa-eye eye-icon"></i>
        <span className="num">{formatCount(count)}</span>
      </div>
    </div>
  </div>
);
const PerfilVideo = ({ perfil, isEditMode = false, onSave }) => {
  const navigate = useNavigate();
  const [videos, setVideos] = useState(Array(15).fill(null));
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [likesState, setLikesState] = useState({});
  const [showLikeLoginBox, setShowLikeLoginBox] = useState(false);
  const [creadorId, setCreadorId] = useState(null);
  const isUserLoggedIn = !!localStorage.getItem('userToken');
  // Detectar sesión activa de creadora (login normal o vía Inspeccionar de Admin)
  useEffect(() => {
    const controller = new AbortController();
    fetch(`${process.env.REACT_APP_AUTH_CREADOR_URL}/check_session.php`, {
      credentials: 'include',
      signal: controller.signal,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.success && data?.user_id) {
          setCreadorId(data.user_id);
        }
      })
      .catch(() => {});
    return () => controller.abort();
  }, []);
useEffect(() => {
  console.log('=== PerfilVideo useEffect INICIADO ===');
  console.log('perfil recibido:', perfil);
  const controller = new AbortController();
  (async () => {
    try {
      setLoading(true);
      setError(null);
      const profileId = perfil?.id ?? perfil?.profile_id ?? perfil?.perfil_id;
      console.log('📌 profileId extraído:', profileId);
      if (!profileId) {
        const errorMsg = 'No se encontró ID de perfil en perfil: ' + JSON.stringify(perfil);
        console.error('❌', errorMsg);
        throw new Error(errorMsg);
      }
      const url = `${API_URL}?id_perfil=${profileId}`;
      console.log('🌐 Llamando API:', url);
      const res = await fetch(url, {
        method: 'GET',
        signal: controller.signal,
      });
      console.log('📡 Response status:', res.status);
      console.log('📡 Response ok:', res.ok);
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }
      const json = await res.json();
      console.log('📦 JSON recibido:', json);
const arr = Array(15).fill(null);
      if (json?.success && json?.data) {
        console.log('✅ API retornó datos exitosos');
        console.log('📊 Total videos recibidos:', json.total);
        // El backend ya entrega el arreglo de 15 posiciones fijas,
        // respetando el orden real (huecos incluidos donde no hay video)
        json.data.forEach((video, idx) => {
          if (video && idx < 15) {
            const videoUrl = `${process.env.REACT_APP_UPLOADS_URL}/ID_${profileId}/${video.videos}?v=${profileId}`;
            console.log(`🎥 Video ${idx + 1}:`, videoUrl);
            arr[idx] = {
              src: videoUrl,
              poster: undefined,
              meta: video,
            };
          }
        });
      } else {
        console.warn('⚠️ API no retornó datos o success=false');
      }
      console.log('📋 Array final de videos:', arr);
      setVideos(arr);
      console.log('✅ setVideos ejecutado');
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('❌ Error en fetch:', err);
        console.error('❌ Error message:', err.message);
        console.error('❌ Error stack:', err.stack);
        setError(err.message || 'Error inesperado');
      }
    } finally {
      setLoading(false);
      console.log('🏁 useEffect finalizado, loading=false');
    }
  })();
  return () => {
    console.log('🧹 Cleanup: abortando controller');
    controller.abort();
  };
}, [perfil]);
  // Cargar estado de "me gusta" + vistas (contador + si el viewer actual ya dio like)
  useEffect(() => {
    const idsActivos = videos
      .filter((v) => v && v.meta && v.meta.estado !== 'pendiente' && v.meta.id)
      .map((v) => v.meta.id);
    if (idsActivos.length === 0) return;
    const userId = localStorage.getItem('userId') || 0;
    const controller = new AbortController();
    (async () => {
      try {
        const identidadParam = isUserLoggedIn
          ? `id_viewer=${userId}`
          : creadorId
          ? `id_creador=${creadorId}`
          : `id_viewer=0`;
        const url = `${process.env.REACT_APP_PUBLICACIONES_URL}/get_estado_likes.php?tipo_contenido=video&ids=${idsActivos.join(',')}&${identidadParam}`;
        const res = await fetch(url, { signal: controller.signal });
        const json = await res.json();
        if (json?.success && Array.isArray(json.data)) {
          const nuevoEstado = {};
          json.data.forEach((item) => {
            nuevoEstado[item.id] = {
              liked: item.liked,
              count: item.likes_count,
              vistas: item.vistas_count,
            };
          });
          setLikesState((prev) => ({ ...prev, ...nuevoEstado }));
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('❌ Error al cargar estado de likes/vistas:', err);
        }
      }
    })();
    return () => controller.abort();
  }, [videos, isUserLoggedIn, creadorId]);
  const handleToggleLike = async (videoId) => {
    if (!isUserLoggedIn && !creadorId) {
      setShowLikeLoginBox(true);
      return;
    }
    const userId = localStorage.getItem('userId');
    setLikesState((prev) => {
      const current = prev[videoId] || { liked: false, count: 0, vistas: 0 };
      return {
        ...prev,
        [videoId]: {
          ...current,
          liked: !current.liked,
          count: current.liked ? Math.max(current.count - 1, 0) : current.count + 1,
        },
      };
    });
    try {
      const formData = new FormData();
      if (isUserLoggedIn) {
        formData.append('ID_U_viewer', userId);
      } else {
        formData.append('ID_U_creador', creadorId);
      }
      formData.append('tipo_contenido', 'video');
      formData.append('contenido_id', videoId);
      const response = await fetch(`${process.env.REACT_APP_PUBLICACIONES_URL}/toggle_like.php`, {
        method: 'POST',
        body: formData,
      });
      const result = await response.json();
      if (result.success) {
        setLikesState((prev) => ({
          ...prev,
          [videoId]: { ...prev[videoId], liked: result.liked, count: result.likes_count },
        }));
      }
    } catch (err) {
      console.error('❌ Error al dar like al video:', err);
    }
  };
  const registrarVista = async (videoId) => {
    if (!videoId) return;
    try {
      const formData = new FormData();
      formData.append('tipo_contenido', 'video');
      formData.append('contenido_id', videoId);
      formData.append('token', getViewerToken());
      const response = await fetch(`${process.env.REACT_APP_PUBLICACIONES_URL}/registrar_vista.php`, {
        method: 'POST',
        body: formData,
      });
      const result = await response.json();
      if (result.success && result.contado) {
        setLikesState((prev) => {
          const current = prev[videoId] || { liked: false, count: 0, vistas: 0 };
          return {
            ...prev,
            [videoId]: { ...current, vistas: (current.vistas || 0) + 1 },
          };
        });
      }
    } catch (err) {
      console.error('❌ Error al registrar vista del video:', err);
    }
  };
  const openVideoModal = (videoSrc, videoIndex) => {
    if (videoSrc && videoSrc !== '/api/placeholder/180/180') {
      const videoId = videos[videoIndex]?.meta?.id;
      setSelectedVideo({ src: videoSrc, index: videoIndex, id: videoId });
      setIsModalOpen(true);
      registrarVista(videoId);
    }
  };
const closeModal = () => {
  setIsModalOpen(false);
  setSelectedVideo(null);
};
const handlePrevVideo = (e) => {
  e.stopPropagation();
  let prevIndex = selectedVideo.index - 1;
  while (prevIndex >= 0 && !videos[prevIndex]) {
    prevIndex--;
  }
  if (prevIndex >= 0 && videos[prevIndex]) {
    const videoId = videos[prevIndex]?.meta?.id;
    setSelectedVideo({ src: videos[prevIndex].src, index: prevIndex, id: videoId });
    registrarVista(videoId);
  }
};
const handleNextVideo = (e) => {
  e.stopPropagation();
  let nextIndex = selectedVideo.index + 1;
  while (nextIndex < videos.length && !videos[nextIndex]) {
    nextIndex++;
  }
  if (nextIndex < videos.length && videos[nextIndex]) {
    const videoId = videos[nextIndex]?.meta?.id;
    setSelectedVideo({ src: videos[nextIndex].src, index: nextIndex, id: videoId });
    registrarVista(videoId);
  }
};
const touchStartX = React.useRef(null);
const handleTouchStart = (e) => {
  touchStartX.current = e.touches[0].clientX;
};
const handleTouchEnd = (e) => {
  if (touchStartX.current === null) return;
  const diff = touchStartX.current - e.changedTouches[0].clientX;
  if (Math.abs(diff) < 50) return;
  if (diff > 0) {
    handleNextVideo(e);
  } else {
    handlePrevVideo(e);
  }
  touchStartX.current = null;
};
  const handleVideoUpload = (index, event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('video/')) {
      console.log(`Subiendo video ${index + 1}:`, file);
      if (onSave) {
        onSave({
          type: 'video',
          index: index,
          file: file
        });
      }
    } else {
      alert('Por favor selecciona un archivo de video válido');
    }
  };
const handleVideoDelete = async (index) => {
  if (!window.confirm('¿Estás seguro de que quieres eliminar este video?')) {
    return;
  }
  const videoItem = videos[index];
  if (!videoItem?.meta?.videos) {
    alert('No se puede identificar el archivo a eliminar');
    return;
  }
  try {
    const profileId = perfil?.id ?? perfil?.profile_id ?? perfil?.perfil_id;
    const response = await fetch(`${process.env.REACT_APP_PUBLICACIONES_URL}/delete_media.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        tipo: 'video',
        id_perfil: profileId,
        nombre_archivo: videoItem.meta.videos
      })
    });
    const result = await response.json();
    if (result.success) {
      // Actualizar el estado local
      const nuevosVideos = [...videos];
      nuevosVideos[index] = null;
      setVideos(nuevosVideos);
      alert('Video eliminado exitosamente');
      // Notificar al componente padre si existe
      if (onSave) {
        onSave({
          type: 'video_delete',
          index: index,
          success: true
        });
      }
    } else {
      throw new Error(result.error || 'Error al eliminar');
    }
  } catch (error) {
    console.error('Error al eliminar video:', error);
    alert('Error al eliminar el video: ' + error.message);
  }
};
  console.log('🎨 Renderizando PerfilVideo');
  console.log('🎨 Estado actual - loading:', loading, 'error:', error, 'videos con contenido:', videos.filter(v => v !== null).length);
  return (
    <div className="videos-section">
      <h3 className="videos-title">Videos</h3>
      {loading && <div className="videos-loading">Cargando videos...</div>}
      {error && (
        <div className="videos-error">
          Ocurrió un problema al cargar los videos: {error}
        </div>
      )}
      <div className="videos-gallery-content">
        {Array.from({ length: 15 }, (_, i) => {
          const item = videos[i];
          console.log(`🎬 Renderizando slot ${i + 1}, item:`, item);
          const esActiva = item?.src && item?.meta?.estado !== 'pendiente';
          const videoId = item?.meta?.id;
          const likeInfo = videoId ? (likesState[videoId] || { liked: false, count: 0, vistas: 0 }) : { liked: false, count: 0, vistas: 0 };
          return (
            <div key={i} className="video-gallery-item">
{item?.src ? (
                <>
                  <div className="video-container">
                  {item?.meta?.estado === 'pendiente' ? (
                    <div style={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      background: 'linear-gradient(145deg, rgba(106,23,16,0.95), rgba(60,10,5,0.95))',
                      gap: '10px',
                      position: 'absolute',
                      top: 0,
                      left: 0
                    }}>
                      <i className="fas fa-hourglass-half fa-spin" style={{ fontSize: '2.5em', color: '#FFD700' }}></i>
                      <span style={{
                        fontFamily: "'Arial Black', Arial, sans-serif",
                        fontSize: '0.75em',
                        fontWeight: '900',
                        color: '#FFD700',
                        textAlign: 'center',
                        padding: '0 8px',
                        lineHeight: '1.4'
                      }}>
                        PENDIENTE<br/>A REVISIÓN
                      </span>
                    </div>
                  ) : (
                    <>
                      <video
                        src={item.src}
                        className="video-thumbnail"
                        onClick={() => openVideoModal(item.src, i)}
                        preload="metadata"
                        poster={item.poster}
                        controlsList="nodownload"
                        disablePictureInPicture
                        onContextMenu={(e) => e.preventDefault()}
                        onError={(e) => {
                          console.error(`❌ Error al cargar video ${i + 1}:`, item.src);
                          console.error('❌ Error event:', e);
                        }}
                        onLoadedMetadata={(e) => {
                          console.log(`✅ Video ${i + 1} metadata cargada`);
                          e.target.currentTime = 3;
                        }}
                      >
                        Tu navegador no soporta el elemento de video.
                      </video>
                      <div
                        className="video-overlay"
                        onClick={() => openVideoModal(item.src, i)}
                      >
                        <i className="fas fa-play video-play-icon"></i>
                      </div>
                      {isEditMode && (
                        <div className="video-edit-controls">
                          <button
                            className="video-delete-btn"
                            onClick={() => handleVideoDelete(i)}
                            title="Eliminar video"
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </div>
                      )}
                    </>
                  )}
                  </div>
                  {esActiva && (
                    <div className="like-badge-row">
                      <LikeBadge
                        liked={likeInfo.liked}
                        count={likeInfo.count}
                        onClick={() => handleToggleLike(videoId)}
                      />
                      <VistasBadge count={likeInfo.vistas} />
                    </div>
                  )}
                </>
              ) : (
                <div className="video-placeholder">
                  <img
                    src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
                    alt="Ulalaaa Logo"
                    style={{ width: '60%', height: '60%', objectFit: 'contain', marginBottom: '8px' }}
                  />
                  <span className="video-placeholder-text">Video {i + 1}</span>
                  {isEditMode && (
                    <div className="video-upload-area">
                      <input
                        type="file"
                        accept="video/*"
                        onChange={(e) => handleVideoUpload(i, e)}
                        className="video-file-input"
                        id={`video-upload-${i}`}
                      />
                      <label
                        htmlFor={`video-upload-${i}`}
                        className="video-upload-label"
                      >
                        <i className="fas fa-upload"></i>
                        Subir Video
                      </label>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
{isModalOpen && selectedVideo && (
  <div className="video-modal" onClick={closeModal}>
    <div className="video-modal-content" onClick={(e) => e.stopPropagation()} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
      <span className="close-video-modal" onClick={closeModal}>
        &times;
      </span>
      {/* Flecha izquierda */}
      {selectedVideo.index > 0 && videos.slice(0, selectedVideo.index).some(v => v) && (
        <button className="video-nav-btn video-nav-prev" onClick={handlePrevVideo}>
          <i className="fas fa-chevron-left"></i>
        </button>
      )}
<video
  src={selectedVideo.src}
  controls
  autoPlay
  muted
  className="modal-video"
  controlsList="nodownload"
  disablePictureInPicture
  onContextMenu={(e) => e.preventDefault()}
>
  Tu navegador no soporta el elemento de video.
</video>
      {/* Flecha derecha */}
      {selectedVideo.index < videos.length - 1 && videos.slice(selectedVideo.index + 1).some(v => v) && (
        <button className="video-nav-btn video-nav-next" onClick={handleNextVideo}>
          <i className="fas fa-chevron-right"></i>
        </button>
      )}
      {selectedVideo.id && (
        <div className="like-badge-row like-badge-row-modal">
          <LikeBadge
            liked={(likesState[selectedVideo.id] || {}).liked || false}
            count={(likesState[selectedVideo.id] || {}).count || 0}
            onClick={() => handleToggleLike(selectedVideo.id)}
          />
          <VistasBadge count={(likesState[selectedVideo.id] || {}).vistas || 0} />
        </div>
      )}
      <div className="video-modal-info">
        <p>Video {selectedVideo.index + 1}</p>
      </div>
    </div>
  </div>
)}
      {showLikeLoginBox && (
        <div className="seguir-login-overlay" onClick={() => setShowLikeLoginBox(false)}>
          <div className="login-required-box" onClick={(e) => e.stopPropagation()}>
            <i className="fas fa-lock"></i>
            <h3>Para dar me gusta debes iniciar sesión</h3>
            <button
              className="btn-inicia-sesion"
              onClick={() => {
                const profileId = perfil?.id ?? perfil?.profile_id ?? perfil?.perfil_id;
                localStorage.setItem('returnToProfile', profileId);
                navigate('/acceso_viewer');
              }}
            >
              INICIA SESIÓN
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
export default PerfilVideo;
